import { HttpClient } from '../HttpClient';
/**
 * * Get ReadyCash Company Settings
 **/

export const GetReadyCashCompanySetting = async () => {
  try {
    const response = await HttpClient.get(`/api/v1/company/setting`);
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
